<template>
  <v-app>
    <BrandNav />
    <div v-if="catalogPreview" class="local-catalog-notice" role="status">
      Local preview · Live public catalog · Checkout disabled
    </div>

    <!-- Main Content -->
    <v-main>
      <FirstSipOffer v-if="route.name !== 'OrderConfirmation'" :expanded="route.name === 'Home'" />
      <router-view />
    </v-main>

    <BrandFooter />

    <!-- Global Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      location="top"
      class="shop-snackbar"
      multi-line
      rounded="lg"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn
          v-for="action in (snackbar.actions || [])"
          :key="action.text"
          :to="action.to"
          variant="outlined"
          color="white"
          size="small"
          @click="action.handler?.(); snackbar.show = false"
        >
          {{ action.text }}
        </v-btn>
        <v-btn variant="text" color="white" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useCartStore } from '@/stores/cart'
import { useSnackbar } from '@/composables/useSnackbar'
import axios from 'axios'
import BrandNav from '@/components/brand/BrandNav.vue'
import BrandFooter from '@/components/brand/BrandFooter.vue'
import FirstSipOffer from '@/components/brand/FirstSipOffer.vue'
import { catalogPreview } from '@/config/localPreview'

const router = useRouter()
const route = useRoute()
const cartStore = useCartStore()
const { snackbar } = useSnackbar()

// State
const isLoggedIn = ref(false)

// Computed
const cartCount = computed(() => cartStore.itemCount)

// Methods
const logout = async () => {
  try {
    await axios.post('/auth/logout')
  } catch (error) {
    console.error('Logout failed:', error)
  }

  localStorage.removeItem('token')
  localStorage.removeItem('user')
  delete axios.defaults.headers.common['Authorization']

  isLoggedIn.value = false
  router.push('/')
}

// Check authentication status
onMounted(() => {
  const token = localStorage.getItem('token')
  isLoggedIn.value = !!token
})
</script>

<style>
/* Keep feedback below the persistent navigation, including on phones. */
:root { --shop-nav-height: 90px; }
html { scroll-padding-top: calc(var(--shop-nav-height) + 20px); }
.shop-snackbar { padding-top: var(--shop-nav-height) !important; }
@media (max-width: 960px) {
  :root { --shop-nav-height: 77px; }
}
/* Global styles for DTC */
.v-btn {
  text-transform: none !important;
}

/* Custom class for app bar buttons to use unified black color */
.app-bar-btn-primary,
.app-bar-btn-primary .v-btn__content,
.app-bar-btn-primary .v-icon {
  color: rgba(0, 0, 0, 0.87) !important;
}

/* DTC uses the shared font system from SCSS */
/* Primary font (Western Light) is applied via shared styles */

.v-main {
  padding: 0 !important;
}

.v-application {
  background: var(--bj-bg) !important;
}
</style>

<style scoped>
.local-catalog-notice { padding: 9px 20px; text-align: center; background: #24513b; color: #fff5e6; font: 500 13px/1.4 Arial, sans-serif; }
</style>
